import React from 'react';
import { SVGIcon } from '../../SVGIcon';

interface FixedElementBadgeProps {
  /** Text displayed in the disclaimer tooltip */
  disclaimerText: string;
  /** Externally control tooltip visibility (e.g. on mobile via tap state) */
  isOpen?: boolean;
}

/**
 * Circular badge with wrench icon + question mark overlay.
 * Shows a disclaimer tooltip on hover.
 * Used in paint measurements ("Element naprawiany") and glass control ("Element wymieniany").
 */
export const FixedElementBadge: React.FC<FixedElementBadgeProps> = ({ disclaimerText, isOpen }) => {
  return (
    <div className="relative inline-flex group/badge">
      <div className="relative w-[30px] h-[30px]" aria-label={disclaimerText}>
        {/* Wrench circle */}
        <div className="absolute bottom-0 right-0 flex items-center justify-center w-[27px] h-[27px] rounded-full bg-[#0064FF]">
          <SVGIcon name="wrench-tool" size={12} fill="white" />
        </div>
        {/* Question mark circle */}
        <div className="absolute top-0 left-0 flex items-center justify-center w-[14px] h-[14px] rounded-full bg-white">
          <span className="text-[9px] font-bold text-[#0064FF] leading-none">?</span>
        </div>
      </div>

      {/* Tooltip on hover or when externally opened */}
      <div className={`absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 pointer-events-none transition-opacity duration-150 ${
        isOpen ? 'opacity-100' : 'opacity-0 group-hover/badge:opacity-100'
      }`}>
        <div className="bg-[#0064FF] text-white text-xs font-semibold px-3 py-2 rounded-[5px] shadow-lg whitespace-nowrap">
          {disclaimerText}
        </div>
        <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[#0064FF]" />
      </div>
    </div>
  );
};
